// Dữ liệu mẫu + hàm thuần cho Mint-Box-Calendar (script board: E0, CALS, TASKS, WC). Chưa nối Graph — chỉ đọc.
export type EvKind = 'int' | 'cus' | 'cut' | 'inv' | 'off' | 'team' | 'room';
export type Rsvp = 'yes' | 'maybe' | 'no' | 'none';
export interface CalEvent {
  id: number; d: string; s?: number; e?: number; all?: boolean; span?: number; k: string; kind: EvKind;
  place?: string; rep?: string; job?: string; mail?: string; att: Array<[string, Rsvp]>; org?: string;
}

export const VIEWER = 'DAVID';
/** Hôm nay của dữ liệu mẫu (board: 22/Oct/2026 09:14). */
export const TODAY = '2026-10-22';
export const NOW_H = 9 + 14 / 60;
/** Ca làm việc mẫu đọc từ WorkCalendar (tblClientInfo) — dữ liệu, không phải luật. */
export const WC = { am: [8, 12], pm: [13.5, 17.5], src: 'WorkCalendar (tblClientInfo)' } as const;
export const H0 = 7;
export const H1 = 19;
export const PX = 58;

export const EVENTS: CalEvent[] = [
  { id: 1, d: '2026-10-19', s: 9, e: 9.5, k: 'Giao ban CS đầu ngày', kind: 'int', place: 'Teams', rep: 'Lặp lại T2–T6', att: [['DAVID', 'yes'], ['MAITTN', 'yes'], ['HOATTN', 'yes'], ['THUYNTT', 'yes']], org: 'MAITTN' },
  { id: 2, d: '2026-10-19', s: 14, e: 15, k: 'RUITONGVN-SC · kế hoạch lô Q4', kind: 'cus', place: 'Teams', job: 'SE260639142', att: [['Anh Tâm · RUITONGVN-SC', 'yes'], ['DAVID', 'yes'], ['MAITTN', 'yes']], org: 'DAVID' },
  { id: 3, d: '2026-10-20', s: 9, e: 9.5, k: 'Giao ban CS đầu ngày', kind: 'int', place: 'Teams', rep: 'Lặp lại T2–T6', att: [['DAVID', 'yes'], ['MAITTN', 'yes']], org: 'MAITTN' },
  { id: 4, d: '2026-10-20', s: 10.5, e: 11.5, k: 'Review giá Q4 tuyến Mỹ', kind: 'int', place: 'Phòng họp lớn · 235 Cộng Hòa', att: [['PHILIP', 'yes'], ['DAVID', 'yes'], ['ANDG', 'maybe']], org: 'PHILIP' },
  { id: 5, d: '2026-10-21', s: 9, e: 9.5, k: 'Giao ban CS đầu ngày', kind: 'int', place: 'Teams', rep: 'Lặp lại T2–T6', att: [['DAVID', 'yes'], ['MAITTN', 'yes']], org: 'MAITTN' },
  { id: 6, d: '2026-10-21', s: 13.5, e: 14.5, k: 'Đào tạo SOP Booking mới', kind: 'team', place: 'Phòng đào tạo', att: [['PhuongHT', 'yes'], ['TranTPB', 'yes'], ['DAVID', 'maybe']], org: 'PhuongHT' },
  { id: 7, d: '2026-10-22', s: 9, e: 9.5, k: 'Giao ban CS đầu ngày', kind: 'int', place: 'Teams', rep: 'Lặp lại T2–T6', att: [['DAVID', 'yes'], ['MAITTN', 'yes']], org: 'MAITTN' },
  { id: 8, d: '2026-10-22', s: 10, e: 10.5, k: 'Gọi YML xác nhận chỗ 2×40HC', kind: 'int', place: 'Gọi điện', job: 'SE260639142', mail: 'Booking Confirmation YMLU-SGN-884512', att: [['DAVID', 'yes'], ['PhuongHT', 'yes']], org: 'DAVID' },
  { id: 9, d: '2026-10-22', s: 14, e: 15, k: 'NAMMY · lô mây tre đi SIN', kind: 'cus', place: 'Văn phòng 235 Cộng Hòa', job: 'SL260643180', mail: 'Nhờ HANA kéo cont và khai hải quan lô mây tre', att: [['Chị Hằng · NAMMY', 'yes'], ['DAVID', 'yes'], ['MAITTN', 'maybe']], org: 'DAVID' },
  { id: 10, d: '2026-10-22', s: 16, e: 16, k: 'SI cut-off · SE260639142', kind: 'cut', job: 'SE260639142', place: 'YM CERTAINTY 089N · từ HANA Ezy', att: [] },
  { id: 11, d: '2026-10-23', s: 9, e: 9, k: 'VGM cut-off · SE260639142', kind: 'cut', job: 'SE260639142', place: 'YM CERTAINTY 089N · từ HANA Ezy', att: [] },
  { id: 12, d: '2026-10-23', s: 11, e: 11, k: 'CY cut-off · SE260639142', kind: 'cut', job: 'SE260639142', place: 'Cát Lái · từ HANA Ezy', att: [] },
  { id: 13, d: '2026-10-23', s: 12, e: 12, k: 'Hạn xác nhận Draft · SGNGM0089431', kind: 'cut', job: 'SE260639112', place: 'ONE COMPETENCE 112E · từ thư hãng tàu', mail: 'Draft B/L + Debit note · SGNGM0089431', att: [] },
  { id: 14, d: '2026-10-23', s: 15, e: 16, k: 'Giao ban Kinh doanh tuần 44', kind: 'inv', place: 'Phòng họp lớn 235 Cộng Hòa', mail: 'Lời mời: Giao ban Kinh doanh tuần 44', att: [['PHILIP', 'yes'], ['DAVID', 'none'], ['TUANNT', 'none'], ['ANDG', 'none']], org: 'PHILIP' },
  { id: 15, d: '2026-10-24', s: 11, e: 11, k: 'ETD YM CERTAINTY 089N', kind: 'cut', job: 'SE260639142', place: 'Cát Lái', att: [] },
  { id: 16, d: '2026-10-21', s: 15.5, e: 16.5, k: 'Phòng họp lớn · đã đặt', kind: 'room', place: 'Phòng họp lớn', att: [['ANDG', 'yes']], org: 'ANDG' },
  { id: 17, d: '2026-10-20', all: true, k: 'Thăm kho NAMMY · Bình Dương', kind: 'cus', place: 'Bình Dương', att: [['DAVID', 'yes'], ['MAITTN', 'yes']], org: 'DAVID' },
  { id: 18, d: '2026-10-27', all: true, span: 3, k: 'Nghỉ phép năm · DAVID', kind: 'off', place: 'Đơn nghỉ HANA Mee · đã duyệt 20/Oct · người thay MAITTN', att: [] },
  { id: 19, d: '2026-10-26', s: 9, e: 9.5, k: 'Giao ban CS đầu ngày', kind: 'int', place: 'Teams', rep: 'Lặp lại T2–T6', att: [['DAVID', 'yes'], ['MAITTN', 'yes']], org: 'MAITTN' },
  { id: 20, d: '2026-10-26', s: 14, e: 15, k: 'Bàn giao việc trước nghỉ phép', kind: 'int', place: 'Teams', att: [['DAVID', 'yes'], ['MAITTN', 'yes']], org: 'DAVID' },
  { id: 21, d: '2026-11-02', all: true, k: 'Nghỉ bù (WorkCalendar #cty)', kind: 'off', place: 'Ngày nghỉ riêng công ty · tblClientInfo', att: [] },
  { id: 22, d: '2026-10-16', s: 10, e: 11, k: 'Họp hãng tàu ONE · giá Q4', kind: 'cus', place: 'Văn phòng ONE', att: [['DAVID', 'yes']], org: 'DAVID' },
  { id: 23, d: '2026-10-30', s: 10, e: 11, k: 'Review KPI tháng 10', kind: 'int', place: 'Phòng họp lớn', att: [['PHILIP', 'yes'], ['DAVID', 'none']], org: 'PHILIP' },
];

export type CalKey = 'me' | 'cut' | 'off' | 'team' | 'room';
export const CALS: ReadonlyArray<{ key: CalKey; label: string; color: string }> = [
  { key: 'me', label: 'Lịch của tôi', color: 'var(--pri)' },
  { key: 'cut', label: 'Cut-off job · HANA Ezy', color: 'var(--warn)' },
  { key: 'off', label: 'Nghỉ lễ & nghỉ phép', color: 'var(--lb)' },
  { key: 'team', label: 'Lịch nhóm CS / BKG', color: 'var(--ok)' },
  { key: 'room', label: 'Phòng họp lớn', color: 'var(--d-blue)' },
];
export const calOf = (e: CalEvent): CalKey => (e.kind === 'cut' ? 'cut' : e.kind === 'off' ? 'off' : e.kind === 'team' ? 'team' : e.kind === 'room' ? 'room' : 'me');

export const TASKS: ReadonlyArray<[string, string]> = [
  ['Gửi BC YMLU-SGN-884512 cho khách', 'SE260639142 · hôm nay'],
  ['Xác nhận Draft SGNGM0089431', 'hạn 23/Oct 12:00'],
  ['Đối soát debit tháng 10 · QUEKYCORP', 'trước 25/Oct'],
];

export const RS_OPTS: ReadonlyArray<[Exclude<Rsvp, 'none'>, string]> = [['yes', 'Chấp nhận'], ['maybe', 'Có thể'], ['no', 'Từ chối']];
export const RS_LABEL: Record<Rsvp, [string, string]> = {
  yes: ['Đã nhận', 'var(--ok)'], maybe: ['Có thể', 'var(--warn)'], no: ['Từ chối', 'var(--err)'], none: ['Chưa trả lời', 'var(--lb)'],
};
export const KIND_LABEL: Record<EvKind, string> = {
  int: 'Họp nội bộ', cus: 'Họp với khách / đối tác', cut: 'Mốc cut-off của job · tự đồng bộ từ HANA Ezy, không sửa ở đây',
  inv: 'Lời mời họp', off: 'Ngày nghỉ', team: 'Lịch nhóm', room: 'Đặt phòng họp',
};
/** [nền, vạch trái, chữ] theo loại sự kiện (KS của board). */
export const KS: Record<EvKind, [string, string, string]> = {
  int: ['var(--pri-bg)', 'var(--pri)', 'var(--link)'],
  cus: ['var(--ok-bg)', 'var(--ok)', 'var(--ok)'],
  cut: ['var(--warn-bg)', 'var(--warn)', 'var(--warn)'],
  inv: ['var(--card)', 'var(--pri)', 'var(--link)'],
  off: ['var(--sub)', 'var(--lb)', 'var(--tx2)'],
  team: ['var(--ok-bg)', 'var(--ok)', 'var(--tx)'],
  room: ['var(--ctl)', 'var(--d-blue)', 'var(--tx2)'],
};

// ---- ngày (UTC, chỉ để vẽ lưới; hạn nghiệp vụ vẫn qua WorkCalendar) ----
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const DOW = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
export const mkDate = (y: number, m: number, d: number) => new Date(Date.UTC(y, m, d));
export const dateOf = (k: string) => new Date(k + 'T00:00:00Z');
export const keyOf = (dt: Date) => dt.toISOString().slice(0, 10);
export const addDays = (dt: Date, n: number) => mkDate(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate() + n);
export const monOf = (dt: Date) => addDays(dt, -((dt.getUTCDay() + 6) % 7));
export const fmtDM = (dt: Date) => String(dt.getUTCDate()).padStart(2, '0') + '/' + MON[dt.getUTCMonth()];
export const hm = (h: number) => String(Math.floor(h)).padStart(2, '0') + ':' + (h % 1 ? String(Math.round((h % 1) * 60)).padStart(2, '0') : '00');

export type CalView = 'week' | 'work' | 'day' | 'month';
export function daysOf(view: CalView, anchor: Date): Date[] {
  const wk0 = monOf(anchor);
  if (view === 'day') return [anchor];
  return Array.from({ length: view === 'work' ? 5 : 7 }, (_, i) => addDays(wk0, i));
}
export function titleOf(view: CalView, anchor: Date): string {
  if (view === 'month') return `Tháng ${anchor.getUTCMonth() + 1}/${anchor.getUTCFullYear()}`;
  if (view === 'day') return `${DOW[anchor.getUTCDay()]} ${fmtDM(anchor)}/${anchor.getUTCFullYear()}`;
  const ds = daysOf(view, anchor);
  return `${fmtDM(ds[0]!)} – ${fmtDM(ds[ds.length - 1]!)}/${ds[0]!.getUTCFullYear()}`;
}
export function covers(e: CalEvent, dt: Date): boolean {
  if (!e.all) return e.d === keyOf(dt);
  const a = dateOf(e.d);
  return dt >= a && dt < addDays(a, e.span || 1);
}
export const isOffDay = (evs: CalEvent[], dt: Date) => evs.some((e) => e.kind === 'off' && e.all && covers(e, dt));

/** Xếp làn sự kiện trong ngày (đặt cạnh nhau khi trùng giờ), như board. */
export function layoutDay(evs: CalEvent[]): Array<{ e: CalEvent; ln: number; n: number }> {
  const sorted = evs.filter((e) => !e.all).sort((a, b) => a.s! - b.s!);
  const lanes: number[] = [];
  const out = sorted.map((e) => {
    let ln = 0;
    while (lanes[ln] != null && lanes[ln]! > e.s!) ln++;
    lanes[ln] = Math.max(e.e!, e.s! + 0.5);
    return { e, ln };
  });
  const n = Math.max(1, lanes.length);
  return out.map((o) => ({ ...o, n }));
}
export const whenOf = (e: CalEvent) =>
  (e.all ? 'Cả ngày · ' : '') + DOW[dateOf(e.d).getUTCDay()] + ' ' + fmtDM(dateOf(e.d)) + '/2026' +
  (e.all ? (e.span ? ` · ${e.span} ngày` : '') : ' · ' + (e.s === e.e ? hm(e.s!) : hm(e.s!) + ' – ' + hm(e.e!)));

// ---- sự kiện mới + trợ lý chọn giờ (script board: nw, SL, busyFor) ----
export interface NewEv { d: string; s: number; dur: number; k: string; att: Array<[string, Rsvp]>; place: 'teams' | 'office' | 'cust'; rem: number; rep: 'none' | 'wd' | 'wk'; job: string }
/** Các mốc nửa giờ trợ lý hiển thị (trong ca WorkCalendar mẫu). */
export const SL = [9, 9.5, 10, 10.5, 11, 11.5, 13.5, 14, 14.5, 15, 15.5, 16, 16.5];
export const ADD_OPTS = ['MAITTN', 'PhuongHT', 'PHILIP', 'Anh Tâm · RUITONGVN-SC'];
const BUSY_SEED: Record<string, Array<[number, number]>> = { MAITTN: [[10.5, 11.5]], PhuongHT: [[14, 15]], 'Anh Tâm · RUITONGVN-SC': [[9, 10], [15, 16.5]], PHILIP: [[13.5, 14.5]] };
export const blankNew = (d: string, s: number, dur = 1): NewEv => ({ d, s, dur, k: '', att: [[VIEWER, 'yes']], place: 'teams', rem: 15, rep: 'none', job: '' });
export function busyFor(evs: CalEvent[], who: string, dk: string): Array<[number, number]> {
  const b = evs.filter((e) => e.d === dk && !e.all && e.s !== e.e && e.att.some((a) => a[0] === who)).map((e) => [e.s!, e.e!] as [number, number]);
  return b.concat(BUSY_SEED[who] ?? []);
}
export const isBusy = (evs: CalEvent[], who: string, dk: string, h: number) => busyFor(evs, who, dk).some(([a, b]) => h < b && h + 0.5 > a);
export function suggestSlots(evs: CalEvent[], n: NewEv): number[] {
  const free = (h: number) => {
    for (let x = h; x < h + n.dur; x += 0.5) if (!SL.includes(x) || n.att.some((a) => isBusy(evs, a[0], n.d, x))) return false;
    return true;
  };
  return SL.filter(free).slice(0, 4);
}
export function hasConflict(evs: CalEvent[], n: NewEv): boolean {
  for (const a of n.att) for (let x = n.s; x < n.s + n.dur; x += 0.5) if (isBusy(evs, a[0], n.d, x)) return true;
  return false;
}
export const PLACE_LABEL = { teams: 'Teams', office: 'Văn phòng 235 Cộng Hòa', cust: 'Tại khách' } as const;
export const REP_LABEL = { none: '', wd: 'Lặp lại mỗi ngày làm việc (WorkCalendar)', wk: 'Lặp lại hằng tuần' } as const;
export function eventFromNew(id: number, n: NewEv): CalEvent {
  return {
    id, d: n.d, s: n.s, e: n.s + n.dur, k: n.k.trim() || 'Cuộc họp mới', kind: n.att.some((a) => /·/.test(a[0])) ? 'cus' : 'int',
    place: PLACE_LABEL[n.place], job: n.job || '', rep: REP_LABEL[n.rep], att: n.att.map(([k]) => [k, k === VIEWER ? 'yes' : 'none'] as [string, Rsvp]), org: VIEWER,
  };
}
